import FoodBanner from './FoodBanner'
import OrderApp from './OrderApp'
import { lazy, Suspense } from 'react'

const FoodVendor = lazy(() => import("./FoodVendor"));
const FoodDelivery = lazy(() => import("./FoodDelivery"));
const HealthIndustries = lazy(() => import("../healthcare/HealthIndustries"));
const FoodAdmin = lazy(() => import("./FoodAdmin"));
const FoodAddon = lazy(() => import("./FoodAddon"));
const FoodSmbs = lazy(() => import("./FoodSmbs"));
const FoodSpeed = lazy(() => import("./FoodSpeed"));
const IndustryPricing = lazy(() => import("../industries/IndustryPricing"));
const ShuttleAppreciation = lazy(() => import("../shuttle_software/ShuttleAppreciation"));
const ShuttleItNeed = lazy(() => import("../shuttle_software/ShuttleItNeed"));
const TaxiFaq = lazy(() => import("../taxiDispatchSoftware/TaxiFaq"));


const faqData = [
  {
    id: "0",
    question: "01. Why choose Mobility Infotech to develop my food delivery app?",
    answer: "The primary challenges associated with off-the-shelf solutions are quite apparent. Initially, while acquiring and implementing such software is faster than developing a custom suite, you will need to either modify the off-the-shelf product to fit your business processes or adjust your workflows to align with the software. Both alternatives can be time-intensive and expensive, undermining the benefits of off-the-shelf software. Furthermore, by dedicating resources to custom software development, you gain complete ownership of the solution.",
  },
  {
    id: "1",
    question: "02. Why should I create an app for my food delivery service?",
    answer: "A dedicated app enhances customer convenience, streamlines orders, and boosts brand visibility. It simplifies operations and allows you to offer personalized features, improving customer satisfaction and loyalty.",
  },
  {
    id: "2",
    question: "03. How can I create an app like Uber Eats and DoorDash?",
    answer: "To build an app like Uber Eats or DoorDash, you need to define your target audience, choose essential features (like tracking, payment options, and user profiles), and partner with an experienced development team for a scalable solution.",
  },
  {
    id: "3",
    question: "04. How much does it cost to develop a food delivery app?",
    answer: "The cost of a food delivery app depends on factors such as features, platform (iOS, Android, or both), design complexity, and the development team. It's best to consult experts for a tailored estimate.",
  },
  {
    id: "4",
    question: "05. How much time will it take to develop a food delivery app?",
    answer: "The development time varies based on app complexity, features, and team efficiency. Generally, a basic app can take 3-6 months, while more advanced apps may take longer.",
  },
  {
    id: "5",
    question: "06. What key features should I include in my food ordering app?",
    answer: "Essential features include user-friendly navigation, real-time tracking, secure payment options, restaurant menus, customer reviews, and a robust admin panel for seamless management.",
  },
  {
    id: "6",
    question:
      "07. How much can I expand my business with this solution?",
    answer: "A food delivery app can exponentially grow your business by reaching a broader audience, improving operational efficiency, and fostering customer retention through personalized services.",
  },
  {
    id: "7",
    question: "08. What do healthcare software development companies do?",
    answer: "These companies specialize in building software for patient management, appointment scheduling, telemedicine, and data security to improve efficiency and compliance in healthcare operations.",
  },
];

export default function FoodAndGrocery() {
  return (
    <>
      <FoodBanner />
      <OrderApp />

      <Suspense fallback={null}>
        <FoodVendor />
        <FoodDelivery />
        <FoodAdmin />
        <HealthIndustries />
        <FoodAddon />
        <FoodSmbs />
        <FoodSpeed />
        <IndustryPricing />
        <ShuttleAppreciation />
        <ShuttleItNeed />
        <TaxiFaq faqData={faqData} />
      </Suspense>
    </>
  )
}
